var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeadlinePlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#497BFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_272_5690)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5C15.4142 5 15.75 5.33579 15.75 5.75V6.5H17.25C18.2165 6.5 19 7.2835 19 8.25V10.8759V12.1259V17.25C19 18.2165 18.2165 19 17.25 19H6.75C5.7835 19 5 18.2165 5 17.25V12.1259V10.8759V8.25C5 7.2835 5.7835 6.5 6.75 6.5H8.25V5.75C8.25 5.33579 8.58579 5 9 5C9.41421 5 9.75 5.33579 9.75 5.75V6.5H14.25V5.75C14.25 5.33579 14.5858 5 15 5ZM8.25 8V8.75C8.25 9.16421 8.58579 9.5 9 9.5C9.41421 9.5 9.75 9.16421 9.75 8.75V8H14.25V8.75C14.25 9.16421 14.5858 9.5 15 9.5C15.4142 9.5 15.75 9.16421 15.75 8.75V8H17.25C17.3881 8 17.5 8.11193 17.5 8.25V10.5315C17.4201 10.5109 17.3363 10.5 17.25 10.5H6.75C6.66367 10.5 6.5799 10.5109 6.5 10.5315V8.25C6.5 8.11193 6.61193 8 6.75 8H8.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_272_5690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadlinePlan);
export default __webpack_public_path__ + "static/media/DeadlinePlan.8840f2d09e3c3a74e57a61f2b9433b23.svg";
export { ForwardRef as ReactComponent };